<template>
  <section class="relative bg-white text-center py-16 mt-20"
  style="background-image: url('/mapa-data-center/map-fundo.png')">
    <!-- Texto superior -->
    <div class="mb-8">
      <h2 class="text-2xl md:text-3xl font-semibold">Nossos Data Center</h2>
      <p class="text-gray-500">Servidores localizado nos EUA , CANADÁ</p>
    </div>

    <!-- Mapa com pontos -->
    <div class="relative flex justify-center items-center">
      <div class="relative w-full max-w-5xl">
        <img src="/mapa-data-center/map.png" alt="Mapa" class="w-full h-auto" />

        <!-- Container absoluto para os pontos -->
        <div class="absolute top-0 left-0 w-full h-full">
          <div
            v-for="(point, index) in points"
            :key="index"
            class="absolute group"
            :style="{ top: point.top, left: point.left }"
          >
            <!-- Animação de destaque (ping aleatório) -->
            <span
              class="absolute w-5 h-5 rounded-full block"
              :class="highlightIndex === index ? 'bg-corbolamapa animate-ping opacity-60' : ''"
            ></span>

            <!-- Ponto fixo -->
            <span
              class="relative z-10 w-5 h-5 rounded-full border-2 border-white bg-corbolamapa block"
            ></span>

            <!-- Nome ao passar o mouse -->
            <div
              class="absolute -top-7 left-1/2 -translate-x-1/2 text-xs text-white bg-black bg-opacity-70 px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
            >
              {{ point.name }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Texto inferior -->
    <div class="mt-10 text-center">
      <p class="text-sm text-gray-400 mb-2">
        Prestamos serviços de hospedagem com qualidade desde 2000
      </p>
      <p class="font-semibold mb-1">
        Somos especialista em hospedagem Java e Node.js com paineis exclusivos e próprios.
      </p>
      <p class="mb-6">
        Fornecemos suporte especializado para o seu negócio
      </p>

    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from 'vue'

// Pontos com nome e coordenadas relativas
const points = [
  { name: 'Canadá', top: '25.8%', left: '14.6%' },
  { name: 'Virgínia', top: '37.6%', left: '22.0%' },
  { name: 'Texas', top: '42.2%', left: '17.1%' },
  { name: 'Califórnia', top: '43.4%', left: '12.9%' }
]

const highlightIndex = ref(0)

onMounted(() => {
  setInterval(() => {
    // Gera um novo índice aleatório diferente do atual
    let next
    do {
      next = Math.floor(Math.random() * points.length)
    } while (next === highlightIndex.value)

    highlightIndex.value = next
  }, 1500)
})
</script>

<style scoped>
.bg-corbolamapa {
  background-color: corbolamapa;
}
</style>
